<template>
  <div class="home">
    <div v-if="token !== 'fceb81089b6f419aa62f5e0b82e33efe'">
      <div class="header">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item v-for="image in images" :key="image.id" @click="goHeaderLink(image.redirectPage)">
            <img :src="image.imgUrl" />
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="hello-world" @click="goBind()">
        <van-skeleton v-if="userInfo.headimgurl == ''" title avatar :row="2" />
        <div v-if="userInfo.headimgurl != ''">
          <van-image round width="56px" height="56px" :src="userInfo.headimgurl" />
          <div v-if="fanUserInfo.userAccount == ''" class="hello-box">
            <h4 class="hello-name">{{userInfo.nickname}}</h4>
            <span v-if="isBind" class="bind-link">点击绑定</span>
            <span v-if="!isBind" class="bind-link">点击查看业务进度</span>
          </div>
          <div v-if="fanUserInfo.userAccount != ''" class="hello-box">
            <h4 class="hello-name">{{fanUserInfo.userAccount}}&nbsp;&nbsp;{{fanUserInfo.userName}}</h4>
            <span class="bind-link">账单金额：{{waterBillInfo.totalCharge}}</span>
            <span v-if="waterBillInfo.ispay == 1" class="bind-link">已缴纳</span>
            <span v-if="waterBillInfo.ispay == 0" class="bind-link-red">未缴纳</span>
          </div>
        </div>
      </div>
      <div v-for="item in items" :key="item.id" class="grid-parent-block">
        <h2 v-if="item.titleName != null" class="home-doc-name">{{item.titleName}}</h2>
        <van-grid :column-num="3" square>
          <van-grid-item v-for="(sub, index) in item.subMenuForms" :key="sub.id" :text="sub.name" @click="goPage(sub)">
            <van-icon v-if="sub.iconType == 1" class="defont" slot="icon" :color="sub.iconColor" size="28" :name="sub.iconUrl"></van-icon>
            <van-icon v-if="sub.iconType == 2" class="iconfont" class-prefix="icon" slot="icon" :color="sub.iconColor" :name="sub.iconUrl"></van-icon>
            <van-image v-if="sub.iconType == 3" class="icon-img" slot="icon" :src="filePath + sub.iconUrl" :data-index="index" />
            <!-- <van-image width="24" height="28" slot="icon" v-if="index == 0" src="http://file.wisewater.cn/group1/M01/0E/E0/rBAABWBvsuWAM_anAAAElsquG2I666.png" />
            <van-image width="24" height="28" slot="icon" v-if="index == 1" src="http://file.wisewater.cn/group1/M01/0E/E0/rBAABWBvsySANmwHAAAD0T6GTp8301.png" />
            <van-image width="24" height="28" slot="icon" v-if="index == 2" src="http://file.wisewater.cn/group1/M01/0E/E0/rBAABWBvszSAU9VDAAAFMHNe2H0185.png" /> -->
          </van-grid-item>
        </van-grid>
      </div>
    </div>
    <div v-else>
      <div>
        <van-swipe class="my-swipe-all" :autoplay="3000" indicator-color="white">
          <van-swipe-item v-for="image in images" :key="image.id" @click="goHeaderLink(image.redirectPage)">
            <img :src="image.imgUrl" />
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="grid-parent-block-swipe">
        <van-swipe class="my-swipe-all" indicator-color="#0099ff">
          <van-swipe-item v-for="(subMenuItem, itemIndex) in subMenuList" :key="itemIndex">
            <van-grid :column-num="4" :border="false" square>
              <van-grid-item v-for="(sub, index) in subMenuItem" :key="sub.id" :text="sub.name" @click="goPage(sub)">
                <van-icon v-if="sub.iconType == 1" class="defont" slot="icon" :color="sub.iconColor" size="28" :name="sub.iconUrl"></van-icon>
                <van-icon v-if="sub.iconType == 2" class="iconfont" class-prefix="icon" slot="icon" :color="sub.iconColor" :name="sub.iconUrl"></van-icon>
                <van-image v-if="sub.iconType == 3" class="icon-img" slot="icon" :src="filePath + sub.iconUrl" :data-index="index" />
              </van-grid-item>
            </van-grid>
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="com-wrap">
        <div class="com-title">
          <span></span>
          <h3>业务推荐</h3>
        </div>
        <div class="service">
          <a v-for="item in busList" :key="item.id" :href="item.visitUrl">
            <div class="service-text">
              <h4>{{ item.name }}</h4>
              <span>{{ item.iconColor }}</span>
            </div>
            <div class="service-img">
              <van-image :width="40" :src="filePath + item.iconUrl" />
            </div>
          </a>
        </div>
      </div>
      <div class="com-wrap">
        <div class="com-title">
          <span></span>
          <h3>水务信息</h3>
        </div>
        <div class="waterinfo">
          <div v-for="item in waterList" :key="item.id" class="waterinfo-div">
            <a :href="item.visitUrl">
              <div class="service-text">
              <h4>{{ item.name }}</h4>
              <span>{{ item.iconColor }}</span>
              </div>
              <div class="service-img">
                <van-image :width="40" :src="filePath + item.iconUrl" />
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="com-wrap">
        <div class="personal">
          <a :href="fanUserAdd">
            <van-image src="https://business.wisewater.cn/zsy_businesshall/pages/main/image/index_personal_01.png" />
          </a>
          <a :href="fanUserList">
            <van-image src="https://business.wisewater.cn/zsy_businesshall/pages/main/image/index_personal_02.png" />
          </a>
          <a :href="fanUserDtl">
            <van-image src="https://business.wisewater.cn/zsy_businesshall/pages/main/image/index_personal_03.png" />
          </a>
        </div>
      </div>
    </div>
    <app-footer v-if="footer_show" :token="token"></app-footer>
  </div>
</template>

<script>
import Vue from 'vue'
import { Icon, Swipe, SwipeItem, Lazyload, Notify, NoticeBar, Grid, GridItem, Image as VanImage, Skeleton } from 'vant'
import { getCarouseReq, getMenuUrlReq } from '@/api/manage'
import { getUserFanReq, getFanBinReq, getWaterBillReq } from '@/api/mobile'
import Footer from '../../components/Footer'
import { timeFix } from '@/utils/util'

Vue.use(Icon)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Lazyload)
Vue.use(NoticeBar)
Vue.use(Notify)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(VanImage)
Vue.use(Skeleton)

export default {
  data () {
    return {
      token: this.$cookies.get('token'),
      openid: this.$cookies.get('openid'),
      timeFix: timeFix(),
      images: [{
        id: '123',
        imgUrl: 'group1/M01/0E/7D/rBAABWBcUvuAaA76AABD5t1QyIY160.jpg'
      }],
      userInfo: {
        headimgurl: '',
        nickname: '未关注公众号'
      },
      fanUserInfo: {
        userAccount: '',
        userName: ''
      },
      waterBillInfo: {
        totalCharge: '0.00',
        ispay: 0
      },
      items: [],
      subMenuList: [],
      del: false,
      footer_show: true,
      isBind: false,
      payUrl: '',
      busList: [],
      waterList: [],
      fanUserAdd: '',
      fanUserList: '',
      fanUserDtl: ''
    }
  },
  components: {
    'app-footer': Footer
  },
  created () {
    // 轮播图
    this.getCarouse()
    // 菜单
    this.getMenu()
    // 业务推荐 水务信息
    if (this.token === 'fceb81089b6f419aa62f5e0b82e33efe') {
      this.fanUserAdd = 'http://service.wisewater.com.cn/zsy_mobile/m/addPeople.do?token=' + this.token + '&openId=' + this.openid
      this.fanUserList = 'http://service.wisewater.com.cn/zsy_mobile/m/feedback_oauth.do?menuid=76e8d7f1-857f-457a-b228-d551086a6778&token=' + this.token
      this.fanUserDtl = 'http://service.wisewater.com.cn/zsy_mobile/m/showPeopleInfo.do?token=' + this.token + '&openId=' + this.token + '&openId=' + this.openid
      this.getBus()
      this.getWater()
    }
    // 获取用户关注信息
    this.getUserFan()
    if (this.$cookies.get('token') === 'e3788d1e116f44ef8a99f8d5dbc3348e' || this.$cookies.get('token') === 'e08c9d1afa954374a0f098adb08edce6') {
      this.isBind = false
    } else {
      this.isBind = true
      // 获取用户绑定信息
      this.getFanBin()
      this.getPayUrl()
    }
  },
  methods: {
    // 轮播图
    getCarouse () {
      const paramsCar = {
        locationType: '11',
        token: this.$cookies.get('token')
      }
      getCarouseReq(paramsCar).then(response => {
        const res = response.data
        if (res.code === 200) {
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].imgUrl.indexOf('http') > -1) {
            } else {
              res.data[i].imgUrl = this.filePath + res.data[i].imgUrl
            }
          }
          this.images = res.data
        }
      })
        .catch((res) => {
          Notify({ type: 'danger', message: '获取轮播图失败' })
        })
    },
    // 菜单
    getMenu () {
      const paramsMenu = {
        location: '11',
        token: this.$cookies.get('token')
      }
      getMenuUrlReq(paramsMenu).then(response => {
        const res = response.data
        console.log(res)
        if (res.code === 200) {
          if (this.token === 'fceb81089b6f419aa62f5e0b82e33efe') {
            var subMenuChildList = []
            var subMenuForms = res.data[0].subMenuForms
            for (let i = 0; i < subMenuForms.length; i++) {
              if (i !== 0 && (i + 1) % 8 === 0) {
                subMenuChildList.push(subMenuForms[i])
                this.subMenuList.push(subMenuChildList)
                subMenuChildList = []
              } else {
                subMenuChildList.push(subMenuForms[i])
              }
            }
            if (subMenuChildList.length > 0) {
              this.subMenuList.push(subMenuChildList)
            }
          }
          this.items = res.data
        }
        console.log(this.subMenuList)
      })
        .catch((res) => {
          Notify({ type: 'danger', message: '获取菜单列表失败' })
        })
    },
    // 获取用户信息
    getUserFan () {
      const paramsFan = {
        token: this.$cookies.get('token'),
        openId: this.$cookies.get('openid')
      }
      getUserFanReq(paramsFan).then(response => {
        const res = response.data
        console.log(res)
        if (res.code === 200) {
          this.userInfo.nickname = res.data.nickname + '，' + this.timeFix
          this.userInfo.headimgurl = res.data.headimgurl === '' ? 'https://cloud.wisewater.cn/group1/M01/14/4A/rBAABWFEMjaAQFgPAAAK_B2eNKU477.png' : res.data.headimgurl
        } else if (res.code === 201) {
          this.userInfo.nickname = '请关注公众号'
          this.userInfo.headimgurl = 'https://cloud.wisewater.cn/group1/M01/14/4A/rBAABWFEMjaAQFgPAAAK_B2eNKU477.png'
        }
      })
        .catch((res) => {
          Notify({ type: 'danger', message: '获取用户信息失败' })
        })
    },
    // 获取绑定信息
    getFanBin () {
      const paramsFanBin = {
        token: this.$cookies.get('token'),
        openId: this.$cookies.get('openid')
      }
      // 获取绑定信息
      getFanBinReq(paramsFanBin).then(response => {
        const res = response.data
        if (res.length > 0) {
          const userAccountCookies = this.$cookies.get('userAccount')
          for (let i = 0; i < res.length; i++) {
            if (userAccountCookies === res[i].account_no) {
              break
            } else {
              this.$cookies.set('userAccount', res[0].account_no, '30d')
              this.$cookies.set('userName', res[0].account_name, '30d')
              break
            }
          }
          this.fanUserInfo.userAccount = this.$cookies.get('userAccount')
          this.fanUserInfo.userName = this.$cookies.get('userName')

          // 获取用户欠费信息
          const paramsWaterBill = {
            token: this.$cookies.get('token'),
            openId: this.$cookies.get('openid'),
            accountNo: this.$cookies.get('userAccount')
          }
          getWaterBillReq(paramsWaterBill).then(response => {
            const res = response.data
            if (res.ispay !== undefined) {
              this.waterBillInfo.totalCharge = res.total_charge
              this.waterBillInfo.ispay = res.ispay
            }
          })
            .catch((res) => {
              Notify({ type: 'danger', message: '获取账单数据失败' })
            })
        }
      })
        .catch((res) => {
          Notify({ type: 'danger', message: '获取绑定信息失败' })
        })
    },
    getPayUrl () {
      const paramsMenu = {
        location: '0',
        token: this.$cookies.get('token')
      }
      getMenuUrlReq(paramsMenu).then(response => {
        const res = response.data
        if (res.code === 200) {
          this.payUrl = res.data[0].subMenuForms[0].visitUrl
        }
      })
        .catch((res) => {
          Notify({ type: 'danger', message: '获取缴费页面链接失败' })
        })
    },
    // 业务推荐
    getBus () {
      const paramsMenu = {
        location: '12',
        token: this.$cookies.get('token')
      }
      getMenuUrlReq(paramsMenu).then(response => {
        const res = response.data
        console.log(res)
        if (res.code === 200) {
          this.busList = res.data[0].subMenuForms
        }
      })
        .catch((res) => {
          Notify({ type: 'danger', message: '获取业务推荐列表失败' })
        })
    },
    // 水务信息
    getWater () {
      const paramsMenu = {
        location: '13',
        token: this.$cookies.get('token')
      }
      getMenuUrlReq(paramsMenu).then(response => {
        const res = response.data
        console.log(res)
        if (res.code === 200) {
          this.waterList = res.data[0].subMenuForms
        }
      })
        .catch((res) => {
          Notify({ type: 'danger', message: '获取水务信息失败' })
        })
    },
    goPage (sub) {
      const isSecond = sub.isSecond
      const id = sub.id
      var url = sub.visitUrl
      if (url == null) {

      } else if (url.indexOf('fanUserListPortal.do') !== -1) {
        url = url.replace(/%param%/, ('token=' + this.$cookies.get('token') + '&openId=' + this.$cookies.get('openid')))
        window.location.href = url
      } else if (url.indexOf('tel:') !== -1 || url.indexOf('http') !== -1) {
        window.location.href = url
      } else {
        var parentId = ''
        if (isSecond) {
          parentId = id
        }
        this.$router.push({
          path: url,
          query: {
            token: this.$cookies.get('token'),
            parentId: parentId
          }
        })
      }
    },
    goHeaderLink (url) {
      if (url == null) {

      } else if (url.indexOf('http') !== -1) {
        window.location.href = url
      } else {
        this.$router.push({
          path: url,
          query: {
            token: this.$cookies.get('token')
          }
        })
      }
    },
    goBind () {
      if (this.isBind) {
        const url = this.payUrl
        window.location.href = url
      } else {
        this.$router.push({
          name: 'scheduleList',
          params: {
            index: 0
          },
          query: {
            token: this.$cookies.get('token')
          }
        })
      }
    },
    // 是否显示底部
    footer: function (bool) {
      this.footer_show = bool
    }
  }
}
</script>

<style lang="less" scoped>
  .header {
    width: 100%;
    position: relative;
    z-index: 0;
    overflow: hidden;
  }
  .header::after {
    content: '';
    width: 120%;
    height: 130px;
    position: absolute;
    left: -10%; // 椭圆左边隐藏10%，右边隐藏10%
    top: 0;
    border-radius: 0 0 50% 50%; // 左上角，右上角，右下角，左下角
    background: #008ACB;
    z-index: 1;
  }
  .my-swipe {
    margin: 12px 12px 0 12px;
    z-index: 9999;
  }
  .my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    text-align: center;
  }
  .my-swipe .van-swipe-item img {
    width: 100%;
    border-radius: 10px;
  }
  .hello-world {
    margin: 12px;
    padding: 15px;
    background-color: #FFF;
    border-radius: 10px;
    // 参数一：水平方向阴影偏移距离，负值往左偏
    // 参数二：垂直方向阴影偏移距离，负值往上偏
    // 参数三：扩散大小
    // 参数四：阴影尺寸
    // 参数五：颜色
    box-shadow: 0 1px 3px 0 rgba(0,0,0,0.1);
  }
  .hello-box {
    display: inline-block;
    height: 56px;
    line-height: 18px;
    margin-left: 10px;
    vertical-align: middle;
  }
  .hello-name {
    font-size: 16px;
    margin: 4px;
  }
  .bind-link {
    margin: 4px;
    font-size: 13px;
    color: #077fd8;
  }
  .bind-link-red {
    margin: 4px;
    font-size: 13px;
    color: red;
  }
  .grid-parent-block {
    margin: 12px 12px 0;
    background-color: #FFF;
    border-radius: 10px;
    box-shadow: 0 1px 3px 0 rgba(0,0,0,0.1);
  }
  .grid-parent-block .home-doc-name {
    margin: 0;
    padding: 16px;
    color: rgba(8, 8, 8, 0.6);
    font-weight: bold;
    font-size: 15px;
    line-height: 16px;
    background-color: #fff;
    border-radius: 10px 10px 0 0;
  }
  .grid-parent-block .van-image {
    vertical-align: middle;
  }
  .grid-parent-block .van-image, .iconfont {
    width: 40px;
    height: 40px;
    padding: 10px;
    vertical-align: middle;
    border-radius: 50%;
    // opacity: .7;
    box-shadow: 2px 2px 10px rgb(167 196 250 / 30%);
  }
  .grid-parent-block .defont {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    padding: 10px;
    vertical-align: middle;
    border-radius: 50%;
    // opacity: .7;
    box-shadow: 2px 2px 10px rgb(167 196 250 / 30%);
  }
  .grid-parent-block .icon-img {
    width: 24px;
    height: 24px;
  }
  /deep/ .grid-parent-block-swipe .van-grid-item__text {
    margin-top: 0;
    font-size: 12px;
  }
  /deep/ .grid-parent-block-swipe .van-swipe__indicator {
    background-color: #000;
  }
  /deep/ .grid-parent-block-swipe .van-swipe__indicators {
    bottom: 0;
  }
  /deep/ .van-grid-item__content {
    padding: 0;
    background: none;
  }
  /deep/ .van-grid-item__content::after {
    // border-width: 0;
  }
  /deep/ .van-grid-item__text {
    margin-top: 8px;
    font-size: 13px;
  }
  // 旧主题样式
  .my-swipe-all {
    margin: 0;
    padding: 0;
    z-index: 9999;
  }
  .my-swipe-all .van-swipe-item {
    line-height: 0;
  }
  .my-swipe-all .van-swipe-item img {
    width: 100%;
  }
  .grid-parent-block-swipe {
    background-color: #FFF;
    padding-bottom: 10px;
  }
  .grid-parent-block-swipe .van-image {
    vertical-align: middle;
  }
  .grid-parent-block-swipe .van-image, .iconfont {
    width: 40px;
    height: 40px;
    padding: 10px;
    vertical-align: middle;
  }
  .grid-parent-block-swipe .defont {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    padding-top: 10px;
    vertical-align: middle;
  }
  .grid-parent-block-swipe .icon-img {
    width: 32px;
    height: 32px;
  }
  .com-wrap {
    margin-top: 5px;
    padding-top: 12px;
    background-color: #FFF;
  }
  .com-wrap .com-title {
    display: flex;
    align-items: center;
    padding: 0 10px 12px;
    border-bottom: 2px solid;
    border-bottom-color: rgba(0,153,255,.8);
  }
  .com-title span {
    width: 4px;
    height: 12px;
    background-color: #0099ff;
    border-radius: 1px;
  }
  .com-title h3 {
    margin: 0;
    padding-left: 7px;
    font-size: 16px;
    color: #0099ff;
  }
  .com-wrap .service {
    display: flex;
    flex-wrap: wrap;
  }
  .service a {
    display: flex;
    align-items: center;
    padding: 15px 10px;
    width: calc(50% - 20.5px);
    border-bottom: 1px solid #dddddd;
    border-right: 1px solid #dddddd;
  }
  .service a:nth-child(even) {
    border-right: none;
  }
  .service-text {
    flex: 1;
    line-height: 10px;
  }
  .service-text h4 {
    margin: 0;
    font-size: 12.8px;
    font-weight: 400;
    color: #000;
  }
  .service-text span {
    font-size: 12px;
    color: #999999;
  }
  .service-img {
    line-height: 0;
  }
  .service-img img {
    width: 40px;
  }
  .waterinfo {
    display: flex;
    flex-wrap: wrap;
    padding: 15px 7px 11px;
  }
  .waterinfo .waterinfo-div {
    display: flex;
    width: 50%;
  }
  .waterinfo-div a {
    display: flex;
    align-items: center;
    margin: 0 2px 4px;
    padding: 15px 10px;
    width: 100%;
    background-color: rgba(0,153,255,.1);
    border-radius: 2px;
  }
  .com-wrap .personal {
    display: flex;
    justify-content: space-around;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 5px;
    padding-bottom: 10px;
  }
  .personal a {
    margin: 0 2px;
  }
</style>
